<template lang="html">
  <div class="modal-wrapper change-offer">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ modalData.title }}
      <questionmark :id="56" :toast="true" />
    </div>
    <div v-if="productInfo">
      <div class="info">
        <span class="info-key">{{ $t("details.details.available") }}:</span>
        <div class="info-value">{{ productInfo.available }}</div>
      </div>
      <div class="info">
        <InputView
          @input="checkQuantity"
          @change="checkQuantity"
          onkeydown="if(event.key==='-'){event.preventDefault();}"
          type="number"
          :label="$t('details.details.buyingQuantity')"
          v-model="quantity"
          name="quantity"
          min="1"
          :max="parseInt(productInfo.available)"
        />
      </div>
      <div class="info">
        <dropdown
          :defaultText="$t('details.details.purchaseTerms')"
          :selected="terms"
          :label="$t('details.details.purchaseTerms')"
          :list="termsList"
          @changeOption="terms = $event"
        />
      </div>
      <div v-if="terms && terms.value === 1" class="info">
        <span class="info-key">{{ $t("details.details.price") }}:</span>
        <dropdown
          :defaultText="$t('details.details.price')"
          :selected="selectedPrice"
          :list="getPricesDropdown"
          @changeOption="changeSelectedPrice"
        />
      </div>
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn dark-blue">
        {{ $t("main.yes") }}
      </div>
      <div @click="closeModal()" class="btn dark-blue outlined">
        {{ $t("main.no") }}
      </div>
    </div>
  </div>
</template>

<script>
import Questionmark from "@/components/questionmark.vue";
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import Dropdown from "@/components/dropdown.vue";
import InputView from "@/components/shared/testInput.vue";
export default {
  name: "changeOfferModal",
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  components: {
    Dropdown,
    Questionmark,
    InputView
  },
  data() {
    return {
      productInfo: null,
      quantity: null,
      terms: null,
      selectedPrice: null
    };
  },
  mounted() {
    this.getProductInfo();
  },
  methods: {
    ok() {
      let params = {
        off_quantity: this.quantity,
        pro_id: this.productInfo.pro_id,
        off_id: this.modalData.off_id
      };
      if (!this.quantity) {
        this.$toast.error(this.$t("details.purchase.missingQuantityError"), {
          duration: 8000
        });
        return;
      }
      if (!this.terms) {
        this.$toast.error(this.$t("details.purchase.termsError"), {
          duration: 8000
        });
        return;
      }
      if (this.terms && this.terms.value === 1 && this.selectedPrice === null) {
        this.$toast.error(this.$t("details.purchase.priceError"), {
          duration: 8000
        });
        return;
      }
      if (this.selectedPrice === null) {
        params.prc_id = this.getPricesDropdown[0].value;
      } else {
        params.prc_id = this.selectedPrice.value;
      }
      api
        .patchOffer(params)
        .then(res => {
          console.log(res);
          this.$toast.success(this.$t("details.purchase.purchaseSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("details.purchase.purchaseError"), {
            duration: 8000
          });
        })
        .finally(() => {
          this.$emit("refresh");
          this.modalData.ok();
        });
      eventBus.$emit("closeModal");
    },
    closeModal() {
      eventBus.$emit("closeModal");
    },
    getProductInfo() {
      const params = {
        id: this.modalData.id,
        off_id: this.modalData.off_id
      };
      api
        .editOffer(params)
        .then(res => {
          res.data.available = parseInt(res.data.available);
          this.productInfo = res.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    changeSelectedPrice(option) {
      this.selectedPrice = option;
    },
    checkQuantity(_, e) {
      if (parseInt(e.target.value) > parseInt(this.productInfo.available)) {
        this.$toast.error(
          this.$t("details.purchase.quantityLimit") +
            this.productInfo.available,
          {
            duration: 8000
          }
        );
        this.quantity = parseInt(this.productInfo.available);
      } else if (parseInt(e.target.value) < 1) {
        this.quantity = 1;
      } else if (e.target.value === "") {
        // this.quantity = 1
      }
    }
  },
  computed: {
    getPricesDropdown() {
      if (this.productInfo.prices) {
        let prices = [];
        for (var i = 0; i < this.productInfo.prices.length; i++) {
          let obj = {
            value: this.productInfo.prices[i].prc_id,
            label:
              this.productInfo.prices[i].price.toLocaleString("en") +
              " " +
              this.productInfo.cur_id
          };
          prices.push(obj);
        }
        return prices;
      }
      return [];
    },
    termsList() {
      return [
        {
          label: this.$t("dropdown.condition1"),
          value: 1
        },
        {
          label: this.$t("dropdown.condition2"),
          value: 2
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  // overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .info {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .info-key {
      font-weight: normal;
      font-size: 13px;
      line-height: 21px;
      color: #787878;
      margin-right: 10px;
      white-space: nowrap;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
    }
  }

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
<style lang="scss" media="screen">
.modal-wrapper.change-offer {
  .dropdown-wrapper .dropdown {
    max-width: none !important;
  }
}
@media only screen and (max-width: 768px) {
  .modal-wrapper.change-offer {
    .dropdown-wrapper .dropdown {
      max-width: 100% !important;
    }
  }
}
</style>
